// extracted by mini-css-extract-plugin
module.exports = {"tag":"index_tag__1iLD_","newGoodsPrice":"index_newGoodsPrice__1S_yT","m0":"index_m0__uWMMF","small":"index_small__2z4zi","smallTag":"index_smallTag__18m4b"};